exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#form-transfer .vs__dropdown-toggle{position:relative}#form-transfer .vs__actions{position:absolute;right:0;top:12px;background:#fff;padding-left:6px}#form-transfer .vs__actions .vs__clear{position:static}", ""]);

// exports
